export default __webpack_public_path__ + "static/gs-5-businessvalue--mobile-1ddda3a8b4a7ab2b6e831082127adf3c.webp";